const facets = () => {
    const selectors = {
        accordion: '[data-filter-accordion]',
        accordionTitle: '[data-filter-accordion-title]',
        accordionContent: '[data-filter-accordion-content]',
        openOnLoad: 'open-on-load',
        facetsDrawerCount: '[data-mobile-facets-count]',
        facetsDrawerClose: '[data-mobile-facets-close]',
    };
    const classes = {
        filterOpen: 'filter--open',
        noTransition: 'no-transition',
    };
    // Filter Accordions
    const openAccordion = (accordion) => {
        const content = accordion.querySelector(selectors.accordionContent);
        accordion.classList.add(classes.filterOpen);
        content.style.maxHeight = content.scrollHeight + 'px';
    };
    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(selectors.accordionContent);
        accordion.classList.remove(classes.filterOpen);
        content.style.maxHeight = null;
    };
    // Events
    const events = ['load', 'frank-green:filters-ready'];
    events.forEach((event) => {
        window.addEventListener(event, () => {
            const filterAccordions = document.querySelectorAll(selectors.accordion);
            filterAccordions.forEach((accordion) => {
                const title = accordion.querySelector(selectors.accordionTitle);
                const content = accordion.querySelector(selectors.accordionContent);
                if (content.hasAttribute(selectors.openOnLoad)) {
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
                if (title && content) {
                    title.onclick = () => {
                        if (content.style.maxHeight) {
                            closeAccordion(accordion);
                        }
                        else {
                            // Close other accordions
                            // filterAccordions.forEach((accordion) => closeAccordion(accordion));
                            openAccordion(accordion);
                        }
                    };
                }
            });
            const facetsDrawerCount = document.querySelector(selectors.facetsDrawerCount);
            const facetsDrawerClose = document.querySelector(selectors.facetsDrawerClose);
            if (facetsDrawerCount && facetsDrawerClose) {
                facetsDrawerCount.addEventListener('click', () => {
                    facetsDrawerClose.click();
                });
            }
        });
        window.addEventListener('resize', () => {
            const filterAccordions = document.querySelectorAll(selectors.accordion);
            filterAccordions.forEach((accordion) => {
                const content = accordion.querySelector(selectors.accordionContent);
                if (content && content.style.maxHeight) {
                    openAccordion(accordion);
                }
            });
        });
    });
    window.addEventListener('frank-green:filters-ready', () => {
        const filterAccordions = document.querySelectorAll(selectors.accordion);
        filterAccordions.forEach((accordion) => {
            const content = accordion.querySelector(selectors.accordionContent);
            const activeLabel = accordion.querySelectorAll('label.active');
            if (activeLabel.length > 0) {
                content.classList.add(classes.noTransition);
                content.style.maxHeight = content.scrollHeight + 'px';
                setTimeout(() => {
                    content.classList.remove(classes.noTransition);
                }, 200);
            }
            else if (content.hasAttribute(selectors.openOnLoad)) {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
            else {
                closeAccordion(accordion);
            }
        });
    });
    // Open / Close Drawer
    const drawerContainer = document.querySelector('.facets-wrapper menu-drawer details');
    const observerConfig = { attributes: true };
    const observerCallback = () => {
        if (drawerContainer.hasAttribute('open')) {
            const filterAccordions = document.querySelectorAll(selectors.accordion);
            filterAccordions.forEach((accordion) => {
                const content = accordion.querySelector(selectors.accordionContent);
                if (content.hasAttribute('open-on-load')) {
                    openAccordion(accordion);
                }
            });
        }
        else {
            const filterAccordions = document.querySelectorAll(selectors.accordion);
            filterAccordions.forEach((accordion) => {
                const content = accordion.querySelector(selectors.accordionContent);
                if (!content.hasAttribute('open-on-load')) {
                    closeAccordion(accordion);
                }
            });
        }
    };
    const observer = new MutationObserver(observerCallback);
    if (drawerContainer) {
        observer.observe(drawerContainer, observerConfig);
    }
};
export { facets };
